// extracted by mini-css-extract-plugin
export default {"rejilla":"UserFormModal_rejilla__Ydv3p ui_rejillaDosColumnas12__kYce3"};